"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z20TerminalSetup = void 0;
const Z20CutScene_1 = require("./Z20CutScene");
const Z20SceneNames_1 = require("./Z20SceneNames");
const Z20Setup_1 = require("./Z20Setup");
class Z20TerminalSetup {
    static LevelForever(level) {
        return {
            saveProgress: false,
            shuffleNpcsAndTools: true,
            levels: [Z20Setup_1.Z20Setup.defaultLevels()[level - 1]],
            onWin(scene, config, setup, time) {
                scene.scene.start(Z20SceneNames_1.default.RuleDisplay, { config });
            },
            onLose(scene, config) {
                scene.scene.start(Z20SceneNames_1.default.RuleDisplay, { config });
            }
        };
    }
}
exports.Z20TerminalSetup = Z20TerminalSetup;
Z20TerminalSetup.StandardSetup = {
    saveProgress: true,
    shuffleNpcsAndTools: true,
    levels: Z20Setup_1.Z20Setup.defaultLevels(),
    onWin(scene, config, setup, time) {
        scene.scene.start(Z20SceneNames_1.default.Cutscene, (0, Z20CutScene_1.endGameData)(setup.player.sprite, time));
    },
    onLose(scene, config) {
        scene.scene.start(Z20SceneNames_1.default.Menu);
    }
};
Z20TerminalSetup.PrototypeSetup = {
    saveProgress: false,
    shuffleNpcsAndTools: true,
    levels: Z20Setup_1.Z20Setup.prototypeLevels(),
    onWin(scene, config, setup, time) {
        scene.scene.start(Z20SceneNames_1.default.RuleDisplay, { config });
    },
    onLose(scene, config) {
        scene.scene.start(Z20SceneNames_1.default.RuleDisplay, { config });
    }
};
Z20TerminalSetup.SeedPickSetup = {
    saveProgress: false,
    shuffleNpcsAndTools: true,
    levels: Z20Setup_1.Z20Setup.defaultLevels(),
    onWin(scene, config, setup, time) {
        scene.scene.start(Z20SceneNames_1.default.SeedPicker, { config });
    },
    onLose(scene, config) {
        scene.scene.start(Z20SceneNames_1.default.SeedPicker, { config });
    }
};
Z20TerminalSetup.NoShuffleSetup = {
    saveProgress: false,
    shuffleNpcsAndTools: false,
    levels: Z20Setup_1.Z20Setup.defaultLevels(),
    onWin(scene, config, setup, time) {
        scene.scene.start(Z20SceneNames_1.default.RuleDisplay, { config });
    },
    onLose(scene, config) {
        scene.scene.start(Z20SceneNames_1.default.RuleDisplay, { config });
    }
};
